export const LocationServiceModal = ({ onClose }) => (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-2xl shadow-xl p-4 max-w-md w-full text-center">
        <img
          src="/images/Service-Not-Available.png"
          alt="Service not available"
          className="mx-auto mb-1 w-32 h-32"
        />
        <h2 className="text-xl font-semibold text-primary mb-2">
          We're not in your area yet.
        </h2>
        <p className="text-gray-600 mb-4">
          Our book rental service is growing fast, but we're still expanding to your location.
          If you'd like to be notified or request access, contact us directly!
        </p>
        
        {/* New Contact Info */}
        <div className="mb-4 text-sm text-gray-700 space-y-1">
          <p>Email: <a href="mailto:care@booksatdoorsteps.com" className="text-primary">care@booksatdoorsteps.com</a></p>
          <p>Call: <a href="tel:+919860133100" className="text-primary">+91 9860133100</a> / <a href="tel:+918788734240" className="text-primary">+91 8788734240</a></p>
        </div>
  
        <div className="flex justify-center gap-4">
          <a
            href="/contact-us"
            className="bg-primary text-white px-4 py-2 rounded-md hover:bg-primary-shade4 transition"
          >
            Contact Us
          </a>
        </div>
  
        <button
          onClick={onClose}
          className="mt-4 text-sm text-gray-500 hover:text-gray-700"
        >
          Maybe Later
        </button>
      </div>
    </div>
  );
  